<template>

    <v-row no-gutters>
        <v-col cols="0" class="pa-3 pb-0">
            <h3>Timed tasks</h3>
        </v-col>
        <v-col cols="auto" class="pa-3 pb-0">
            <RefreshBtn :method="() => { refresh() }" :externalLoading="loading"
                :tip="$t('servicesystem.common_objects.job.refresh_list')" :size="'small'" :autoTimer="10000">
            </RefreshBtn>
        </v-col>
        <v-col cols="12">
            <v-data-table :items="plans" :headers="headers" hide-default-footer dense>
                <template v-slot:[`item.status`]="{ item }">
                    <div class="px-2">
                        {{ item.status }}
                    </div>
                </template>

                <template v-slot:[`item.progress`]="{ item }">
                    <v-row v-if="item.task" no-gutters align="center">
                        <v-col cols="0">
                            <v-progress-linear color="primary" :value="lastProgressForTaskId(item.task.taskId)">
                            </v-progress-linear>
                        </v-col>
                        <v-col cols="auto" class="pl-2">
                            {{ lastProgressForTaskId(item.task.taskId) }}%
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:[`item.displayText`]="{ item }">
                    <span v-if="item.task">{{ lastTextForTaskId(item.task.taskId) }}</span>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <v-btn icon color="primary" elevation="0" :disabled="item.active" @click="switchPlan(item)">
                        <v-icon>mdi-play</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" elevation="0" :disabled="item.status == 1 || !(item.active)"
                        @click="play(item)">
                        <v-icon>mdi-skip-forward</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" elevation="0" :disabled="!(item.active)" @click="switchPlan(item)">
                        <v-icon>mdi-stop</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import RefreshBtn from "@/components/Buttons/RefreshDataBtn.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import Vue from "vue";

export default {
    name: "TaskManager",
    components: {
        RefreshBtn
    },

    data() {
        return {
            headers: [
                { "text": "Name", value: "name" },
                { "text": "ETA", value: "eta" },
                { "text": "Status", value: "status", },
                { "text": "Progress", value: "progress", width: "150px" },
                { "text": "Text", value: "displayText", width: "230px" },
                { "text": "Action", value: "action" },
            ],

            loading: false,
            tasks: [],
            plans: [],
            lastTaskUpdates: [],

            statuses: {
                "1": {
                    text: "Running",
                    color: "tertiary"
                },
                "0": {
                    text: "Queued",
                    color: "primary"
                },
                "-1": {
                    text: "Stopped",
                    color: "disabled"
                },
            },
        };
    },

    mounted() {
        this.$store.dispatch("NotificationStore/subscribe", [
            SRConst.EventKeys.TaskEvent,
            this.OnTaskEvent
        ]);
        this.refresh();
    },

    beforeDestroy() {
        this.$store.dispatch("NotificationStore/unsubscribe", [
            SRConst.EventKeys.TaskEvent,
            this.OnTaskEvent
        ]);
    },

    methods: {
        refresh() {
            this.loading = true;
            ClientAPIMixin.methods.getPlans()
                .then(response => {
                    this.plans = response;
                    ClientAPIMixin.methods.getRunningTasks()
                        .then(response => {
                            this.tasks = response.queue.map(e => {
                                e.progress = 0;
                                e.displayText = '';
                                return e;
                            });
                            this.loading = false;
                        });
                })
        },

        getPlanByName(planname) {
            var plan = this.plans.find(x => x.name == planname);
            return plan;
        },

        switchPlan(plan) {
            console.log(plan);
            if (plan.active) {
                ClientAPIMixin.methods.disablePlan(plan.name).then(() => {
                    ClientAPIMixin.methods.getPlans().then(response => {
                        this.plans = response;
                    });
                    ClientAPIMixin.methods.getRunningTasks().then(response => {
                        this.tasks = response.queue.map(e => {
                            e.progress = 0;
                            e.displayText = '';
                            return e;
                        });
                    });
                })
            }
            else {
                ClientAPIMixin.methods.activatePlan(plan.name).then(() => {
                    ClientAPIMixin.methods.getPlans().then(response => {
                        this.plans = response;
                    })
                })
            }
        },

        play(plan) {
            ClientAPIMixin.methods.taskCancelWait(plan.task.taskId)
        },

        lastTextForTaskId(taskId) {
            var lastEvent = this.lastTaskUpdates.find(f => f.taskId == taskId);
            return lastEvent?.displayText ?? '';
        },

        lastProgressForTaskId(taskId) {
            var lastEvent = this.lastTaskUpdates.find(f => f.taskId == taskId);
            return lastEvent?.progress ?? '';
        },

        OnTaskEvent(args) {
            const task = args.task;
            /*
            // omit normal background tasks
            if (task.scheduledCronExpression == null) return;
            */
            var index = this.lastTaskUpdates.findIndex(f => f.taskId == args.taskId);
            task.progress = args.progress ?? '';
            task.displayText = args.displayText ?? '';
            if (index >= 0) {
                Vue.set(this.lastTaskUpdates, index, args.task);
            }
            else {
                this.lastTaskUpdates.push(task);
            }
        }
    },

    computed: {
        mergedTasksAndPlans() {
            var tasks = this.tasks;
            var plans = this.plans;
            var missingPlans = plans.filter(plan => !tasks.find(task => plan.name == task.planName));
            var missingPlansAsTasks = missingPlans.map(plan => {
                return {
                    "planName": plan.name,
                    "status": -1,
                }
            });
            var list = [...tasks, ...missingPlansAsTasks];
            //sort by plan name so the items dont jump arround when you start/stop a plan
            list.sort((a, b) => {
                if (a.planName < b.planName) return -1;
                if (a.planName > b.planName) return 1;
                return 0;
            });
            return list;
        }
    },

    watch: {},
}

</script>